import { IPartsSearchCriteria } from 'parts/types';

import { EMPTY_INVENTORY_FILTER, IInventoryFilterValue } from './InventoryFilter';

export interface IPartSearchFilters {
  inventory: IInventoryFilterValue;
}

export const EMPTY_FILTERS: IPartSearchFilters = {
  inventory: EMPTY_INVENTORY_FILTER,
};

export const hasActiveFilters = (filters: IPartSearchFilters): boolean =>
  filters.inventory.onlyWithInventory;

export const buildSearchCriteria = (
  filters: IPartSearchFilters
): IPartsSearchCriteria | undefined => {
  const { inventory } = filters;

  if (!inventory.onlyWithInventory) {
    return undefined;
  }

  const criteria: IPartsSearchCriteria = { onlyWithInventory: 1 };

  if (inventory.shippingLocation?.id) {
    criteria.inventoryShippingLocationId = inventory.shippingLocation.id;
  }

  return criteria;
};
